var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TestLayout',{attrs:{"title":"Notifications"}},_vm._l((_vm.types),function(button,type){return _c('TestSection',{key:type,attrs:{"subtitle":type}},[_c('Button',{attrs:{"type":button,"label":"Show Notification"},on:{"click":function($event){return _vm.$notifications.add(type, `This is a ${type} notification!`)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }